jQuery($ => {
  class PostsFeed {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._pagination = this._element.find('.o-posts-feed__pagination-wrapper');
      this._page = this._pagination.find('.page-numbers');
      this._posts = this._element.find('.o-posts-feed__feed');
      this._postList = this._posts.find('.m-post-cards__list');
      this._filters = this._element.find('.o-posts-feed__filters .m-filters__button');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      $(document).on('click', '.page-numbers[href]', (e) => this.handlePagination(e));
      this._filters.each((_, filter) => {
        $(filter).on('click', () => {
          this.handleFiltering($(filter).data('value'));
          $(this._filters).not(filter).removeClass('m-filters__button--active');
          $(filter).addClass('m-filters__button--active');
        });
      });
    }

    handlePagination = (e) => {
      e.preventDefault();

      this._activeCategory = this._posts.attr('data-category');
      this._page = parseInt($(e.target).text());

      this.handlePosts(this._page, this._activeCategory);
    }


    handleFiltering = ($category = '') => {
      this.handlePosts(null, $category);
    }

    handlePosts = (page = null, $category = 'all') => {
      $.ajax({
        url: AJAX.url,
        type: 'POST',
        data: {
          action: 'get_posts',
          nonce: AJAX.nonce,
          category: $category,
          paged: page
        },
        success: (response) => {
          if (response.data) {
            this._postList.empty().append(response.data.html);
            this._pagination.empty().html(response.data.pagination);
            this._posts.attr('data-category', $category);
          }
        },
        error: (response) => {
          console.log(response);
        }
      });
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.posts_feed = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].posts_feed = new PostsFeed(_[i], opt);
      else
        ret = _[i].posts_feed[opt].apply(_[i].posts_feed, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  // $('.o-posts-feed').posts_feed();
});